import type { TApplicationStatus } from '@doutorsim/shared/applications'
import type { TUserType } from '../_lib/auth-client.types'

/**
 * Registry of status → actionable button shown on the applications table.
 * Only statuses listed here render a button; others render nothing.
 * Extend this map to wire up buttons for additional statuses.
 */
export type StatusAction = {
  label: string
  allowedFor: TUserType[]
} & (
  | {
      kind: 'link'
      // Joined to the mode-aware application detail prefix by the column's LinkBuilder.
      subpath: string
    }
  | {
      kind: 'release-handoff'
    }
)

const STATUS_ACTIONS: Partial<Record<TApplicationStatus, StatusAction>> = {
  'pending-handoff': {
    kind: 'release-handoff',
    label: 'Liberar proposta',
    allowedFor: ['staff', 'tenant'],
  },
  'pending-declarations-confirmation': {
    kind: 'link',
    label: 'Confirmar Dados',
    subpath: 'data-confirmation',
    allowedFor: ['staff'],
  },
}

export const getStatusAction = (
  status: TApplicationStatus,
  userType: TUserType,
): StatusAction | undefined => {
  const action = STATUS_ACTIONS[status]
  if (!action || !action.allowedFor.includes(userType)) return undefined
  return action
}
